import Diary from "../../components/diary/Diary";
import Rightbar from "../../components/rightbar/Rightbar";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";

import "./profile.css";

export default function Profile() {
  return (
    <>
      <Topbar />
      <div className="profile">
        <Sidebar />
        <div className="profileRight">
          <div className="profileRightTop">
            <div className="profileCover">
              <img src="assets/cover.jpg" alt="" className="profileCoverImg" />
              <img src="assets/person/human_12.jpg" alt="" className="profileUserImg" />
            </div>
            <div className="profileInfo">
              <h4 className="profileInfoName">Kristine Scott</h4>
              <span className="profileInfoDescription">simply me</span>
            </div>
          </div>
          <div className="profileRightBottom">
            <Diary />
            <Rightbar profile />
          </div>
        </div>
      </div>
      {/* Barra online fissa in basso — visibile solo su mobile */}
      <div className="profileOnlineBar">
        <Rightbar />
      </div>
    </>
  );
}
